
































































import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import type { AccountOperator } from '@/api/schema';
import Tooltip from '@/components/tooltip/Tooltip.vue';
import { updateOperator } from '@/api/Onboarding';
import { required, minLength } from '@/helpers/validation';

const defaultFormData = {
  test: true,
  name: ''
};

export default {
  name: 'OnboardingOperatorDialog',
  components: {
    Tooltip
  },
  data(): any {
    return {
      formValid: true,
      nameRules: [(v) => required(v, 'Name'), (v) => minLength(v, 3)],
      formData: { ...defaultFormData }
    };
  },
  computed: {
    ...mapState('Onboarding', [
      'displayOperatorDialog',
      'loading',
      'operatorDialogData',
      'operators',
      'accountInfo'
    ]),
    ...mapGetters('Onboarding', [
      'isDeployedSmartContract',
      'onboardingForm'
    ]),
    isEditDialog(): boolean {
      return !!this.operatorDialogData?.id;
    },
    header(): string {
      return this.isEditDialog ? 'Edit account' : 'New account';
    },
    buttonText(): string {
      return this.isEditDialog ? 'Update' : 'Create';
    },
    disableProdCreation(): boolean {
      if (!this.operators.length) return true;
      const prodOperator = this.operators.find(
        (operator: AccountOperator) => !operator.test
      );
      return !!prodOperator;
    },
    disableTestCreation(): boolean {
      const testOperatorsAmount = this.operators.reduce((acc, operator) => {
        if (operator.test) acc++;
        return acc;
      }, 0);
      return testOperatorsAmount >= 3;
    },
    showAccountTypeChoose(): boolean {
      const { length } = this.operators;

      return length && length < 3;
    }
  },
  watch: {
    displayOperatorDialog(showStatus: boolean): void {
      if (showStatus) {
        this.formData = { ...defaultFormData, ...this.operatorDialogData };
        this.$refs.form?.resetValidation();
      }
    },
    'formData.test': {
      handler(): void {
        if (!this.formData.test) {
          this.formData.name = this.accountInfo.brandName;
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('Onboarding', [
      'showOperatorDialog',
      'hideOperatorDialog',
      'resetOnboardingFormData',
      'getAllOperators'
    ]),
    ...mapMutations('Onboarding', [
      'setNewOperator',
      'setSelectedOperator',
      'setOnboardingFormData'
    ]),
    submitHandler(): void {
      const form = this.$refs.form;
      form.validate();
      this.$nextTick((): void => {
        if (this.formValid && !this.disableEdit) {
          if (!this.isEditDialog) {
            this.createNewOperator();
          } else {
            this.updateOperator();
          }
        }
      });
    },
    createNewOperator(): void {
      if (this.disableTestCreation) {
        this.formData.test = false;
      }
      if (!this.operatorDialogData?.name) {
        this.resetOnboardingFormData();
        this.setOnboardingFormData({ ...this.formData });
      }
      this.setNewOperator({ ...this.formData });
      this.setSelectedOperator({ ...this.formData });
      this.hideOperatorDialog();
      if (this.$route.path !== '/home') this.$router.push('/home');
    },
    updateOperator(): void {
      const form = {
        ...this.onboardingForm,
        ...this.formData
      };

      updateOperator(form).then(() => {
        this.getAllOperators();
        this.hideOperatorDialog();
      });
    }
  }
};
